/**
 * Роли админки и стартовая страница по ролям.
 * Финансовый директор (Prosperpay-1151) видит только раздел «Овердрафт».
 */
export const ADMIN_PANEL_ROLES = [
  'ROLE_SUPER_ADMIN',
  'ROLE_MANAGER',
  'ROLE_ADMIN_PANEL_VIEWER',
  'ROLE_APP_ADMIN',
]

export const FINANCE_DIRECTOR_ROLE = 'ROLE_FINANCE_DIRECTOR'

/**
 * Роли из JWT.
 * @param {string} token - access-токен
 * @return {string[]} authorities
 */
export function rolesFromToken(token) {
  if (!token) return []
  try {
    const tokenData = JSON.parse(atob(token.split('.')[1]))
    return tokenData.authorities || []
  } catch (e) {
    return []
  }
}

/**
 * Можно ли войти в админку с этими ролями.
 * @param {string[]} roles - роли пользователя
 * @return {boolean}
 */
export function canEnterAdmin(roles) {
  return [ ...ADMIN_PANEL_ROLES, FINANCE_DIRECTOR_ROLE ].some((role) => roles.includes(role))
}

/**
 * Первая разрешённая страница: «Компании» для сотрудников админки, «Партнёры» овердрафта для ФД.
 * @param {string[]} roles - роли пользователя
 * @return {string|null} имя маршрута или null, если входить некуда
 */
export function homeRouteName(roles) {
  if (ADMIN_PANEL_ROLES.some((role) => roles.includes(role))) return 'companies'
  if (roles.includes(FINANCE_DIRECTOR_ROLE)) return 'overdraft.partners'
  return null
}
